import React, { useEffect, useRef, useState } from 'react';
import { API_BASE_URL } from 'config.js';
import { downloadConversationImage } from './conversationMediaClient';

export default function ConversationAttachment({ media, token }) {
  const downloadable = ['ready', 'legacy'].includes(media.availability);
  const [url, setUrl] = useState(null), [error, setError] = useState(null), [loading, setLoading] = useState(false), [attempt, setAttempt] = useState(0);
  const element = useRef(null), [visible, setVisible] = useState(typeof IntersectionObserver === 'undefined');
  useEffect(() => {
    if (!element.current || !downloadable || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { setVisible(true); observer.disconnect(); }
    }, { rootMargin: '200px' });
    observer.observe(element.current); return () => observer.disconnect();
  }, [media.id, downloadable]);
  useEffect(() => {
    if (!downloadable) { setUrl(null); setError(null); setLoading(false); return; }
    if (!visible) return;
    const controller = new AbortController(); let objectUrl;
    setUrl(null); setLoading(true); setError(null);
    downloadConversationImage({ id: media.id, sizeBytes: media.sizeBytes, mimeType: media.mimeType }, { apiBase: API_BASE_URL, token, signal: controller.signal })
      .then(blob => {
        if (controller.signal.aborted) return;
        objectUrl = URL.createObjectURL(blob); setUrl(objectUrl);
      }).catch(failure => { if (!controller.signal.aborted) setError(failure.message); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [media.id, downloadable, media.sizeBytes, media.mimeType, token, attempt, visible]);
  if (!downloadable) return <small>Attachment {media.availability || 'unavailable'}{media.fileName ? `: ${media.fileName}` : ''}</small>;
  return <div ref={element} className="conversation-attachment">
    {!visible && <small>Image attachment</small>}
    {loading && <small role="status">Loading image…</small>}
    {url && !error && <>
      <a className="conversation-media-link" href={url} target="_blank" rel="noopener noreferrer" aria-label={`Open ${media.fileName || 'attachment'} full size`}>
        <img className="conversation-media-preview" src={url} alt={media.fileName || 'Message attachment'} onError={() => setError('Image preview could not be displayed.')} />
      </a>
      <a href={url} download={media.fileName || 'attachment'}>Download image</a>
    </>}
    {error && <><small role="alert">{error}</small><button onClick={() => setAttempt(value => value + 1)}>Retry image</button></>}
  </div>;
}
